export default __webpack_public_path__ + "static/media/java_script.22cce50f.svg";